/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * DnR API
 * 地方自治体事業管理システムAPI
 * OpenAPI spec version: 1.0.0
 */

/**
 * 実行ステータス（running: 実行中、completed: 完了、failed: 失敗）
 */
export type JobsExecutionStatus = (typeof JobsExecutionStatus)[keyof typeof JobsExecutionStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const JobsExecutionStatus = {
  running: 'running',
  completed: 'completed',
  failed: 'failed',
} as const;
